import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MenuComponent } from '../menu/menu.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MenuComponent, NgIf, TranslateModule]
})
export class SidebarComponent {
    @Output() public toggleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @HostBinding('class.collapsed')
    public collapsed = false;

    public toggle() {
        this.collapsed = !this.collapsed;
        this.toggleChange.emit(this.collapsed);
    }
}
